import { render, staticRenderFns } from "./Plan.vue?vue&type=template&id=6e163ff4&scoped=true&"
import script from "./Plan.vue?vue&type=script&lang=ts&"
export * from "./Plan.vue?vue&type=script&lang=ts&"
import style0 from "./Plan.vue?vue&type=style&index=0&id=6e163ff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e163ff4",
  null
  
)

export default component.exports